<template>
  <div class="text-xs-center">
    <v-dialog :value="value" @input="$emit('input')" :width="computedWidth" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2 py-0 title-mobile" primary-title>
          {{ computedTitle }}
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <v-btn flat fab small icon @click="$emit('input')" slot="activator">
              <v-icon>close</v-icon>
            </v-btn>
            <span>Cancelar</span>
          </v-tooltip>
        </v-card-title>

        <v-card-text class="pa-0">
          <v-container grid-list-md pa-0>
            <v-flex xs12 pa-0>
              <div class="d-flex">
                <h3 class="ma-3">Colaborador</h3>
                <h3 class="ma-3 text-xs-right">Atividades</h3>
              </div>
              <v-divider></v-divider>
              <v-list class="checklists" v-if="computedWorkflowColaboradores.length">
                <template v-for="(colaborador, index) in computedWorkflowColaboradores">
                  <v-list-tile
                    @click="$emit('workflowColaboradorSelected', colaborador)"
                    active-class="selected"
                    :key="colaborador.IdColaborador"
                  >
                    <v-list-tile-content>
                      <v-list-tile-title>{{ colaborador.Colaborador }}</v-list-tile-title>
                    </v-list-tile-content>

                    <v-list-tile-avatar>
                      {{ colaborador.Atividades }}
                    </v-list-tile-avatar>

                    <v-list-tile-action>
                      {{ colaborador.Atrasadas }}
                    </v-list-tile-action>
                  </v-list-tile>
                  <v-divider
                    v-if="index !== computedWorkflowColaboradores.length - 1"
                    :key="index + colaborador.Colaborador"
                    class="mx-2"
                  ></v-divider>
                </template>
              </v-list>
              <div v-else class="d-flex py-2">
                <span class="text-xs-center font-weight-bold">Nenhum colaborador adicionado à esse workflow.</span>
              </div>
            </v-flex>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Workflow from '@/domain/workflow/Workflow';
import WorkflowColaborador from '@/domain/workflow/WorkflowColaborador';

export default {
  name: 'WorkflowColaboradores',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    workflow: {
      type: Object,
      default: () => new Workflow()
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      workflowColaborador: new WorkflowColaborador()
    }
  },
  computed: {
    ...mapGetters(['workflowColaboradores']),
    computedWorkflowColaboradores() {
      return this.workflowColaboradores.sort((a, b) => a.Atividades - b.Atividades);
    },
    computedTitle() {
      return 'Workflow Colaboradores';
    },
    computedWidth() {
      return this.$vuetify.breakpoint.smAndDown ? '100%' : '60%';
    },
  },
  watch: {
    value(newValue) {
      if (newValue && this.workflow.IdWorkflow) this.fetchWorkflowColaboradores({ id: this.workflow.IdWorkflow, atividades: true });
    }
  },
  methods: {
    ...mapActions(['fetchWorkflowColaboradores']),
    ...mapMutations(['showNotification', 'closeNotification']),
    // async adiciona() {
    //   // TODO: Alterar o responsável da atividade ao selecionar o colaborador do workflow
    // }
  },
}
</script>

<style scoped>
@media screen and (max-width: 480px) {
  .title-mobile {
    font-size: 1.125rem !important;
  }
}
.cursor-pointer {
  cursor: pointer;
}
.selected {
  background: #333;
}
</style>
